import SERVICES from "../data/services.json";

const fallbackImages = [
  "trainer-explaining.jpg",
  "healthcare.jpg",
  "computer.jpg",
  "conseil_formation.jpg",
  "import_export.jpg",
  "restauration.jpg",
];

export function normalizeService(service, index = 0) {
  const title = service?.title || service?.name || "Service Fatihoune";
  const slug =
    service?.slug ||
    service?.name ||
    title
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
  const imageName =
    service?.images?.[0]?.name ||
    service?.image ||
    fallbackImages[index % fallbackImages.length];

  return {
    ...service,
    title,
    slug,
    imageName,
    subtitle: service?.subtitle || title,
    description:
      service?.description ||
      "Une solution Fatihoune pensée pour accompagner vos projets avec méthode et proximité.",
    tags: service?.tags?.length ? service.tags.slice(0, 3) : ["Accompagnement"],
  };
}

export const fallbackServices = SERVICES.services
  .slice(0, 8)
  .map((service, index) => normalizeService(service, index));

export function getServiceImageUrl(service) {
  if (service?.images?.[0]?.name) {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
    const imageName = service.imageName || service.images[0].name;
    return `${backendUrl}/image/${imageName}`;
  }

  return `${process.env.PUBLIC_URL}/assets/images/${service.imageName}`;
}
